// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-landing__media{--cta-background:#e9ecff;--shadow-background:#0a0a3a;position:relative;z-index:2}.product-landing__hero--media img{justify-content:center;max-height:20em;width:auto}@media (min-width:768px){.product-landing__hero--media img{max-height:22em}}@media (min-width:1024px){.product-landing__hero--media img{max-height:25em}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
